export const ErrorBoundary = {
  defaultError: 'This content could not be displayed'
};